var _circle, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-icon": "close",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Close menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.3004,
    cy: 23.3004,
    r: 23.3004,
    fill: "red"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.4023,
    y1: 16.3457,
    x2: 30.3908,
    y2: 30.3342,
    stroke: "black",
    strokeWidth: 1.95139,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16.3455,
    y1: 30.334,
    x2: 30.3339,
    y2: 16.3456,
    stroke: "black",
    strokeWidth: 1.95139,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.72b9478971906f6057f6aff09ae307b0.svg";
export { ForwardRef as ReactComponent };